

(function () {
    'use strict';

    function getDrawer() {
        return document.querySelector('[data-filter-drawer]');
    }
    function openDrawer() {
        var d = getDrawer();
        if (!d) return;
        d.setAttribute('data-open', '');
        d.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
        var d = getDrawer();
        if (!d) return;
        d.removeAttribute('data-open');
        d.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    // delegated: works even after the section is replaced by AJAX
    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-filter-open]')) { openDrawer(); return; }
        if (e.target.closest('[data-filter-close]')) { closeDrawer(); return; }
    });

    document.addEventListener('keydown', function (e) {
        var d = getDrawer();
        if (e.key === 'Escape' && d && d.hasAttribute('data-open')) closeDrawer();
    });
})();


/* lum-catrow — scroll the category row with prev/next buttons (no Swiper). */
(function () {
    'use strict';
    document.querySelectorAll('[data-catrow]').forEach(function (row) {
        var scroll = row.querySelector('[data-catrow-scroll]');
        var prev = row.querySelector('[data-catrow-prev]');
        var next = row.querySelector('[data-catrow-next]');
        if (!scroll) return;

        function step() { return Math.round(scroll.clientWidth * 0.8); }  // ~one screenful

        prev && prev.addEventListener('click', function () {
            scroll.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        next && next.addEventListener('click', function () {
            scroll.scrollBy({ left: step(), behavior: 'smooth' });
        });

        // show/hide arrows at the ends
        function update() {
            var max = scroll.scrollWidth - scroll.clientWidth - 1;
            if (prev) prev.hidden = scroll.scrollLeft <= 0;
            if (next) next.hidden = scroll.scrollLeft >= max;
        }
        scroll.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });
})();